import {GET_FAVORITE, GET_FAVORITE_ERROR} from '../types'
import axios from 'axios'
import { ROUTE, PATH } from "../constants";

export const getFavoriteVendorsAction = (token) => async dispatch => {
    
    try{
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        const API = `${process.env.REACT_APP_SERVER_HOST}${PATH}${ROUTE.GET_FAV}`;
        const res = await axios.get(API,config);
        console.log(res);
        dispatch( {
            type: GET_FAVORITE,
            payload: res.data
        })
    }
    catch(error){
        console.log(error);
        dispatch( {
            type: GET_FAVORITE_ERROR,
            payload: error,
        })
    }

}

